import "./src/styles/global.css"
import "@fontsource/open-sans" 
import "@fontsource/open-sans/500.css"
// gatsby-browser.js
export const onClientEntry = () => {
  if (typeof window !== "undefined") {
    const url = window.location.href;
    //const cleaned = url.replace(/([^:]\/)\/+/g, "$1"); // remove duplicate slashes except after http(s):

     // Remove duplicate slashes except after http(s):
    let cleaned = url.replace(/([^:]\/)\/+/g, "$1");

    // Force trailing slash before query/hash
    cleaned = cleaned.replace(/([^/])(\?|#|$)/, "$1/$2");


    if (url !== cleaned) {
      //window.history.replaceState({}, document.title, cleaned);
       window.location.replace(cleaned);
    } }
};